// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, setDoc } from 'firebase/firestore';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyD2KjDuadtYSAMY0ves753ChBoCIRQvqEM",
  authDomain: "humbertack-workflow.firebaseapp.com",
  projectId: "humbertack-workflow",
  storageBucket: "humbertack-workflow.firebasestorage.app",
  messagingSenderId: "59810649637",
  appId: "1:59810649637:web:741d7ef9f9c50560add1cc"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// getMessaging() must NOT be called at module load time.
// On some mobile browsers, private browsing mode, or non-HTTPS environments
// it throws immediately — which would crash this entire module and silently
// break auth, db, and everything else that imports from firebase.js.
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (err) {
  console.warn('Firebase Messaging is not supported in this environment:', err.message);
}

export { auth, db, messaging, storage, functions };

const VAPID_KEY = 'BN-T58CIdOACoVlgKckTQ62D5aUO0YpU7ng5AbnDAezHO4DI5Fz1u7S5g4fkDCw2hi6idxBRrxYuPoXhZMa8IXk';

export const requestForToken = async (userId) => {
  try {
    if (!userId) {
      console.error('Cannot request token without a user ID.');
      return;
    }

    if (!messaging) {
      console.warn('Messaging not initialised — unsupported environment.');
      return;
    }

    if (!('serviceWorker' in navigator)) {
      console.warn('Service workers are not supported by this browser.');
      return;
    }

    // serviceWorker.ready waits for an *active* SW — critical on mobile PWAs
    // where the SW may still be installing when this runs.
    const registration = await navigator.serviceWorker.ready;

    const currentToken = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    if (currentToken) {
      console.log('FCM Token acquired for user:', userId);
      const userDocRef = doc(db, 'users', userId);
      // setDoc + merge:true works even if the user document doesn't exist yet.
      // The old updateDoc would silently fail (throw) on missing documents.
      await setDoc(
        userDocRef,
        { fcmTokens: { [currentToken]: true } },
        { merge: true }
      );
      console.log('Token successfully saved for user:', userId);
    } else {
      console.warn('No registration token available. Permission may not be granted.');
    }
  } catch (err) {
    console.error('An error occurred while retrieving token:', err);
    throw err;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) return;
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });